<template id="page1">
    <section>
        <div class="row ml-3">
        <!--    <select v-model="salesmanData" class="col-md-6 col-lg-10 mb-5">
                <option v-for="l1 in filterSalesman" v-bind:key="l1">{{l1}}</option>
            </select> -->
        </div>
        <div class="row" v-for="r of rows" v-bind:key="r">
            <div v-for="c of rowColMap[r]" v-bind:key="c" :class="'text-center ml-3 mt-4 '+makeWidth(r, c)">
                <viz1 :viz1="vizDataRowCol[r][c][0]"></viz1>
            </div>
        </div>
    </section>
</template>
<script>
import Viz1 from '@/components/viz1'
import _ from 'lodash'
import axios from 'axios';

export default {
        name: "page1",
        components: {Viz1},
        data: () => ({
            salesmanData:[],
            filterSalesman:'',
            searching: false,
            vizData: [],
            vizDataRowCol: {},
            rows: [],
            rowColMap: {}
        }),
        computed: {},
        created() {
            
            this.loadSummary()
            this.listenToRouter()
        },
        methods: {
            loadSalesman: function () {
                axios.get('/api/salesman-list/')
                .then(res => {
                    this.salesmanData = res.data
                    this.filterSalesman = Array.from(new Set(this.salesmanData.map(c => c.dim1).filter(x => x != null)))
                    console.log("Salesman data:", this.filterSalesman)  
                }, err => {
                    console.log('Error in fetching record', err)
                })
            },
            makeWidth: function (r, c) {
                let v0 = this.vizDataRowCol[r][c][0].vizunitWidthArray
                let defV = ['2', '4', '5']
                let v = v0 && v0.length > 0 ? v0 : defV
                let lg = v[2], md = v[1], sm = v[0]
                return `col-lg-${lg} col-md-${md} col-sm-${sm}`
            },
            loadSummary: function () {
                this.loadSalesman()
                console.info('loading summary')
                let menuParam = this.$route.params.menuId
                let submenuParam = this.$route.params.submenuId
                this.$store.dispatch("loadState").then(() => {
                    let allVizData = this.$store.state.fwScreenConfig

               //   let vizData = allVizData.filter(r => r.menuId === menuParam && r.subMenuId === submenuParam)
                    let vizData = allVizData.filter(r => r.menuId === submenuParam)
                    if (vizData.length === 0) {
                        console.error("No vizdata for the screen, hence Blank Screen..fix data", vizData, vizData.length)
                        return
                    }
                    console.log("Visualization Data", vizData, vizData.length)
                    this.menuName = this.$store.state.menuMasterData.filter(m => m.menuId === menuParam).map(m => m.menuName)[0]
                    this.screenName = this.$store.state.menuMasterFlat.filter(m => m.menuId === submenuParam).map(m => m.menuName)[0]
                    this.menusyspk = this.$store.state.menuMasterData.filter(m => m.menuId === menuParam).map(m => m.syspk)[0]

                    console.log("menusyspk",this.menusyspk)

                    //what we'll do is identify the max rows
                    //then for each row identify the max cols
                    let maxRows = _.max(vizData.map(v => v.positionRow)) + 1
                    let rowColMap = {}
                    _.range(1, maxRows).forEach(rowNum => {
                        rowColMap[rowNum] = _.range(1, _.max(vizData.filter(v => v.positionRow === rowNum).map(v => v.positionColumn)) + 1)
                    })

                    this.rows = _.range(1, maxRows)
                    this.rowColMap = rowColMap
                    let vizDataRowCol = {}
                    _.forEach(rowColMap, (colCount, rowNumStr) => {
                        let rowNum = +rowNumStr
                        vizDataRowCol[rowNum] = {}
                        let rowData = vizData.filter(v => v.positionRow === rowNum)
                        rowColMap[rowNum].forEach(colNum => {
                            vizDataRowCol[rowNum][colNum] = rowData.filter(v => v.positionColumn === colNum)
                        })

                    })
                    this.vizDataRowCol = vizDataRowCol
                    //log the event in audi log
                    //this.$commonFn.auditLog(this.menuName, this.screenName, "", "GET", "Success")
                    this.$commonFn.auditLog(this.menusyspk,submenuParam,this.menuName,this.screenName, "GET", "Success")
                }, err => {
                    console.error("error in getting he viz1 data", err)
                })
            },
            listenToRouter: function () {
                let $this = this
                this.$router.afterEach(function (from, to) {
                    console.log(`router moved to ${from.path} from ${to.path}, page1 viz1 = ${$this.rows.length}`)
                    $this.rows = []
                    setTimeout(() => {
                        $this.loadSummary()
                    }, 300)

                })
            }
        }
    }
</script>